export default {
  任务中心: "Task Center",
  消息提醒: "Message Notification",
  "拜访&审计日程": "Visit & Audit Schedule",
  VCR任务: "VCR Task",
  供应商资质到期预警: "Supplier Qualification Expiration Warning",
  合同到期预警: "Contract Expiration Warning",
  "近6个月采购订单数量/金额趋势":
    "Purchase Order Quantity/Amount Trend in 6 Months",
  剩余: "Remaining",
  天: "days",
  序号: "No.",
  任务标题: "Task Title",
  任务状态: "Task Status",
  全部: "All",
  待办: "Pending",
  已办: "Completed",
  单据类型: "Document Type",
  发起人: "Initiator",
  发起部门: "Initiating Department",
  接收时间: "Receive Time",
  进行中: "In Progress",
  生产物料: "Production Materials",
  非生产物料: "Non-production Materials",
  快捷应用: "Quick Applications",
  代供应商注册: "Register Supplier",
  发起供应商评估: "Initiate Supplier Evaluation",
  创建准入申请: "Create Admission Application",
  创建价格申请: "Create Price Application",
  发起询价: "Initiate Inquiry",
  建立合同: "Create Contract",
  查看更多: "View More",
  未处理: "Pending",
  已询价: "Quoted",
  已转PO: "Transferred to PO",
  已到货: "Received",
  已付款: "Paid",
  待开始: "Pending Start",
  物料质量标准已确定: "Material Quality Standard Confirmed",
  供应商开发与筛选已完成: "Supplier Development and Screening Completed",
  供应商选择与评估已完成: "Supplier Selection and Evaluation Completed",
  样品小试或中试研究已完成: "Sample Pilot or Pilot Study Completed",
  "供应商合格认证已完成（原供应商准入）":
    "Supplier Qualification Certification Completed (Original Supplier Admission)",
  采购任务: "Procurement Tasks",
  寻源任务: "Sourcing Tasks",
  我收到的: "Received by Me",
  我发起的: "Initiated by Me",
  供应商名称: "Supplier Name",
  发起时间: "Initiation Time",
  流程用时: "Process Time",
  小时: "hours",
  分钟: "minutes",
  已结束: "Completed",
  未读: "Unread",
  已读: "Read",
  消息提醒列表: "Message Notification List",
  消息状态: "Message Status",
};
